import defaultConfigs from './default';

const AWS = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id:
    'eu-west-1:c7437939-5bad-4eba-b169-61c2e91851dc',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_Tlu2NG73P',
  aws_user_pools_web_client_id: '5hv0um29n078gh1u8r6dol5sb2',
  oauth: {},
  aws_appsync_graphqlEndpoint:
    'https://42cny5olnfectbpsipzivbxs7i.appsync-api.eu-west-1.amazonaws.com/graphql',
  aws_appsync_region: 'eu-west-1',
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  aws_appsync_apiKey: 'da2-fakeApiId123456',
  aws_cloud_logic_custom: [
    {
      name: 'userapi',
      endpoint: 'https://8opjgu98ml.execute-api.eu-west-1.amazonaws.com/allth',
      region: 'eu-west-1',
    },
  ],
  aws_user_files_s3_bucket: 'clinicardstorage151332-allth',
  aws_user_files_s3_bucket_region: 'eu-west-1',
  Auth: {
    cookieStorage: {
      domain:
        process.env.NODE_ENV === 'production'
          ? 'allergytherapeutics.clinicards.app'
          : 'localhost',
      path: '/',
      expires: 1,
      secure: process.env.NODE_ENV === 'production',
    },
  },
};

const defaultCarepathCards = [];

export default {
  ...defaultConfigs,
  ENABLE_ARTICLES: true,
  ENABLE_CAREPATH: true,
  ENABLE_MEDICAL_PROFILE: true,
  ENABLE_OPERATION_PROFILE: true,
  ENABLE_MANAGEMENT: true,
  ENABLE_ORGANISATION_LEVEL: true,
  AWS,
  defaultCarepathCards,
};
